import { motion } from "framer-motion";
import { Reveal } from "./Motion";
import { SERVICES, SERVICES_NOTE } from "../data/portfolio";

const TILE_INITIAL = { opacity: 0, y: 30 };
const TILE_IN_VIEW = { opacity: 1, y: 0 };
const TILE_VIEWPORT = { once: true, margin: "-40px" };

export default function Services() {
  return (
    <section id="services" className="relative py-24 md:py-36 bg-[#070707] border-y border-white/10 scroll-mt-20" data-testid="services">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="mb-14 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">What I do</p>
          <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-[0.95]">
            Two disciplines, <span className="font-serif-accent italic font-normal">one brand</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={TILE_INITIAL}
              whileInView={TILE_IN_VIEW}
              viewport={TILE_VIEWPORT}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group rounded-2xl border border-white/10 bg-[#0C0C0C] hover:bg-[#101010] transition-colors duration-500 p-8 md:p-12 flex flex-col"
              data-testid={`service-card-${i}`}
            >
              <h3 className="font-display font-bold text-3xl md:text-4xl tracking-tight mb-5 group-hover:translate-x-1 transition-transform duration-500">
                {s.title}
              </h3>
              <p className="text-white/55 leading-relaxed text-lg">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 text-white/55 text-base md:text-lg max-w-2xl" data-testid="services-note">
            {SERVICES_NOTE}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
